<template>
  <h2 class="subtitle has-text-centered locker-name">
    {{ name }}
    <hr style="margin: 0.7rem 0;" />
  </h2>
</template>

<script>
export default {
  props: ["name"]
};
</script>

<style scoped>
@media (max-width: 768px) {
  .locker-name {
    margin-top: 0.3rem;
    margin-bottom: 1.5rem;
  }
}
</style>
